import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useClients, useSettings } from '../hooks/useApi';

const FALLBACK_CLIENTS = [
  { _id: '1', name: 'PTT Group' },
  { _id: '2', name: 'PTTEP' },
  { _id: '3', name: 'SCG' },
  { _id: '4', name: 'OR' },
];

function ClientLogos() {
  const { data: clientsData } = useClients();
  const { data: settings } = useSettings();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });
  const [logoSize, setLogoSize] = useState({ w: 150, h: 70 });
  const [logoRadius, setLogoRadius] = useState(8);
  const [logoGap, setLogoGap] = useState(28);
  const [scrollSpeed, setScrollSpeed] = useState(30);

  useEffect(() => {
    fetch('/api/theme')
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data) {
          setLogoSize({
            w: d.data.clientLogoWidth || 150,
            h: d.data.clientLogoHeight || 70,
          });
          setLogoRadius(Number(d.data.clientLogoRadius) ?? 8);
          setLogoGap(Number(d.data.clientLogoGap) || 28);
          setScrollSpeed(Number(d.data.clientScrollSpeed) || 30);
        }
      })
      .catch(() => {});
  }, []);

  const clients = Array.isArray(clientsData) ? clientsData :
    clientsData?.data || FALLBACK_CLIENTS;

  // Duplicate for infinite scroll effect
  const doubledClients = [...clients, ...clients];

  return (
    <section id="clients" className="clients">
      <div className="container">
        <motion.div
          className="section__header"
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="section__label">{settings?.clients_label || 'Trusted By'}</span>
          <h2 className="section__title">{settings?.clients_title || 'Our Clients'}</h2>
          <div className="divider" />
        </motion.div>
      </div>

      <motion.div
        className="clients__track-wrapper"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        <div className="clients__track" style={{ animationDuration: `${scrollSpeed}s` }}>
          {doubledClients.map((client, idx) => (
            <div key={`${client._id}-${idx}`} className="clients__logo" style={{ margin: `0 ${logoGap / 2}px` }}>
              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.name}
                  className="clients__logo-img"
                  style={{ width: logoSize.w, height: logoSize.h, borderRadius: logoRadius }}
                />
              ) : (
                <span className="clients__logo-text">{client.name}</span>
              )}
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}

export default ClientLogos;
